"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CleanTag = exports.omit = exports.omitProps = void 0;

var _react = _interopRequireDefault(require("react"));

var _primitives = require("../../platform/primitives");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * The default set of props to remove from components rendered by styled-components
 */
var omitProps = ["backgroundColor", "bg", "borderRadius", "color", "display", "fontFamily", "fontSize", "fontStyle", "fontWeight", "height", "letterSpacing", "lineHeight", "m", "maxHeight", "maxWidth", "mb", "minHeight", "minWidth", "ml", "mr", "mt", "mx", "my", "p", "pb", "pl", "pr", "pt", "px", "py", "textAlign", "theme", "width"];
/**
 * Removes entries from an object based on a list of keys
 */

exports.omitProps = omitProps;

var omit = function omit() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var keys = arguments.length > 1 ? arguments[1] : undefined;
  var next = {};

  for (var key in obj) {
    if (keys.indexOf(key) > -1) continue;
    next[key] = obj[key];
  }

  return next;
};

exports.omit = omit;

var tagName = function tagName(tag) {
  return typeof tag === "string" ? tag : tag.displayName || "Tag";
};

function tagBuilder() {
  var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _primitives.View;

  var TagComponent = _react.default.forwardRef(function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$is = _ref.is,
        BaseTag = _ref$is === void 0 ? tag : _ref$is,
        _ref$omitFromProps = _ref.omitFromProps,
        omitFromProps = _ref$omitFromProps === void 0 ? [] : _ref$omitFromProps,
        props = _objectWithoutProperties(_ref, ["is", "omitFromProps"]);

    var ref = arguments.length > 1 ? arguments[1] : undefined;
    return props ? _react.default.createElement(BaseTag, _objectSpread({
      ref: ref
    }, omit(props, [].concat(_toConsumableArray(omitFromProps), omitProps)))) : _react.default.createElement(BaseTag, {
      ref: ref
    });
  });

  TagComponent.displayName = "Clean.".concat(tagName(tag));
  return TagComponent;
}

var DefaultTag = tagBuilder();
/**
 * An element to be used to prevent unwanted props from passing through
 * styled-components to the DOM
 *
 * @example
 *
 * const Component = styled(Tag)`
 *   ${borderRadius};
 * `
 *
 * const Component2 = styled(Tag.as('span'))`
 *  ${background};
 * `
 */

var CleanTag = DefaultTag;
exports.CleanTag = CleanTag;
CleanTag.as = tagBuilder;
//# sourceMappingURL=CleanTag.js.map